/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Secure_1Inputs */

const en_pc_tut_secure_1 = /** @type {(inputs: Pc_Tut_Secure_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the file as usual. PdfCraft asks for the password.`)
};

const zh_pc_tut_secure_1 = /** @type {(inputs: Pc_Tut_Secure_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`像平时一样打开文件，PdfCraft 会提示输入密码。`)
};

/**
* | output |
* | --- |
* | "Open the file as usual. PdfCraft asks for the password." |
*
* @param {Pc_Tut_Secure_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_secure_1 = /** @type {((inputs?: Pc_Tut_Secure_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Secure_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_secure_1(inputs)
	return zh_pc_tut_secure_1(inputs)
});
export { pc_tut_secure_1 as "pc.tut.secure.1" }